import axios from "axios";

export const date_to_nice_date = (date, options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) => {
    if (options !== 'dotted') {
        let parsed_date = date.toLocaleDateString("ca-ES", options)
        return parsed_date.split(',')[1];
    } else {
        let dotted_date = new Date(date)
        let day = dotted_date.getDate() < 10 ? "0" + dotted_date.getDate() : dotted_date.getDate()
        let month = dotted_date.getMonth() + 1 < 10 ? "0" + (dotted_date.getMonth() + 1) : (dotted_date.getMonth() + 1)
        return `${day}.${month}.${dotted_date.getFullYear()}`
    }
}

export const api_urls = {
    daily_crossword_url: process.env.REACT_APP_API_URL + "/minimots/api/v1/",
    all_crosswords_url: process.env.REACT_APP_API_URL + "/minimots/api/v1/crosswords",
}

export const get_data_from_url = async (url) => {
    let data = undefined
    await axios.get(url).then((response) => {
        data = JSON.parse(JSON.stringify(response.data))
    }).catch((error) => { log(error) })
    return data
}

export const get_day_today = (inputdate = null) => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();

    today = dd + '.' + mm + '.' + yyyy;

    return today
}

export function json_to_upper_case(content) {
    content = upper(content)
    return content;
}

function upper(obj) {
    for (var prop in obj) {
        if (typeof obj[prop] === 'string' && prop === 'answer') {
            obj[prop] = obj[prop].toUpperCase();
        }
        if (typeof obj[prop] === 'object') {
            upper(obj[prop]);
        }
    }
    return obj;
}

// eslint-disable-next-line
function get_env_mode() {
    return process.env.REACT_APP_HOST_ENV
}

function get_debug_mode() {
    return process.env.REACT_APP_DEBUG_MODE
}

// eslint-disable-next-line
export function log(...msgs) {
    if (get_debug_mode() === 'true') {
        msgs.forEach(msg => {
            console.log(msg)
        })
    }
}
